import React, { useState } from 'react';

const ContactSection: React.FC = () => {

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const { name, phone, email, service, message } = formData;

    const whatsappMessage = `
Hello, I have a new enquiry:

Name: ${name}
Phone: ${phone}
Email: ${email}
Service: ${service}
Message: ${message}
    `;

    const encodedMessage = encodeURIComponent(whatsappMessage);

    // 👇 Apna WhatsApp number yaha daale (without +)
    const whatsappNumber = "919119901924";

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <section className="py-16 sm:py-18 lg:py-20 bg-gradient-to-br from-yellow-50 via-white to-yellow-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">

          {/* Left : Enquiry Form */}
          <div className="bg-white shadow-2xl rounded-2xl p-6 sm:p-8 border border-gray-100">

            <p className="text-yellow-500 font-semibold uppercase mb-2">
              Request a Quote
            </p>

            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-6">
              Fill Out Our Enquiry Form Now!
            </h2>

            <form className="space-y-5" onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                required
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-500"
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone No."
                  required
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-500"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-500"
                />
              </div>

              <select
                name="service"
                required
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-500"
              >
                <option value="">Select Service</option>
                <option>Architecture Design</option>
                <option>Interior Design</option>
                <option>2D & 3D Planning</option>
                <option>VDA Map Approval</option>
              </select>

              <textarea
                name="message"
                rows={4}
                placeholder="Message"
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-500"
              />

              <button
                type="submit"
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 rounded-lg shadow-lg transition-transform hover:scale-[1.02]"
              >
                SUBMIT
              </button>

            </form>
          </div>

          {/* Right : Map (Same as before) */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
           <iframe title="Google Map showing Varanasi location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249480.34390953404!2d82.78199213159444!3d25.2308496839173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e33095ab775ef%3A0xefa9c540d2ab7d60!2sBraj%20PVC%20Manufacuture%20and%20Wholesale!5e0!3m2!1sen!2sin!4v1758300095554!5m2!1sen!2sin" className="border-0 w-full h-[300px] sm:h-[400px] lg:h-full transform transition-transform duration-500 group-hover:scale-105" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;